function updateBaseWidth () {
    const customEvent = new CustomEvent('baseWidthChange');
    document.dispatchEvent(customEvent);
}

window.addEventListener('resize', updateBaseWidth);
//弹框的方法
function initDragCloseModal(options) {
      const {
        modal,
        panel,
        dragBar,
        list,
        threshold = 50
      } = options;

      // 状态变量
      let startY = 0;
      let isDragging = false;
      let isAnimating = false;
      let isModalOpen = false;
      // 移除scrollTop相关变量（不再需要记录/恢复滚动位置）

      // 核心：仅阻止页面滚动行为，不修改任何样式/定位（彻底解决跳顶）
      function preventPageScroll(e) {
        // 允许list横向滚动、拖动条操作，仅阻止页面级的滚动
        const target = e.target;
        if (target.closest('.list') || target.closest('.drag-bar')) return;
        
        // 阻止所有页面滚动相关的默认行为
        if (e.type === 'touchmove') {
          e.preventDefault();
        } else if (e.type === 'mousewheel' || e.type === 'wheel') {
          e.preventDefault();
        }
      }

      // 锁定页面：仅绑定阻止滚动的事件（不修改body样式）
      function lockPage() {
        if(window.innerWidth > 767) return; // 仅在移动端启用
        // 移动端touchmove
        document.addEventListener('touchmove', preventPageScroll, { passive: false, capture: true });
        // 桌面端滚轮
        document.addEventListener('mousewheel', preventPageScroll, { passive: false, capture: true });
        document.addEventListener('wheel', preventPageScroll, { passive: false, capture: true });
      }

      // 解锁页面：仅移除事件监听
      function unlockPage() {
        if(window.innerWidth > 767) return; // 仅在移动端启用
        document.removeEventListener('touchmove', preventPageScroll, { capture: true });
        document.removeEventListener('mousewheel', preventPageScroll, { capture: true });
        document.removeEventListener('wheel', preventPageScroll, { capture: true });
      }

      // 重置弹窗样式
      function resetModalStyle() {
        panel.style.transform = '';
        panel.classList.remove('show');
        modal.classList.remove('show');
        panel.style.transition = '';

        // if(window.innerWidth <= 767){
        //       document.body.style.overflow = 'auto';
        //   }
      }

      // 开始拖动
      function handleStart(e) {
        if (isAnimating || !e.target.closest('.drag-bar') || !isModalOpen) return;
        
        isDragging = true;
        const touch = e.touches?.[0] || e;
        startY = touch.clientY;
        // 拖动时暂停过渡动画
        panel.style.transition = 'none';
      }

      // 拖动中
      function handleMove(e) {
        if (!isDragging || !isModalOpen) return;
        
        const touch = e.touches?.[0] || e;
        const dy = touch.clientY - startY;

        if (dy > 0) {
          panel.style.transform = `translateY(${dy}px)`;
        }
      }

      // 结束拖动
      function handleEnd() {
        if (!isDragging || !isModalOpen) return;

        isDragging = false;
        isAnimating = true;
        // 恢复丝滑过渡动画
        panel.style.transition = 'transform .8s cubic-bezier(.18, .71, .11, 1)';
        
        const dy = parseInt(panel.style.transform.match(/\d+/g)?.[0] || 0);

        if (dy >= threshold) {
          // 关闭弹窗
         // panel.style.transform = 'translateY(100%)';
          modal.classList.remove('show');
          isModalOpen = false;
          if(window.innerWidth <= 767){
              document.body.style.overflow = 'auto';
          }
          // 动画结束后重置
          setTimeout(() => {
            resetModalStyle();
            unlockPage();
            isAnimating = false;
          }, 800);
        } else {
          // 回弹
          panel.style.transform = 'translateY(0)';
          setTimeout(() => {
            isAnimating = false;
          }, 800);
        }
      }

      // 绑定事件
      dragBar.addEventListener('touchstart', handleStart, { passive: true });
      document.addEventListener('touchmove', handleMove, { passive: true });
      document.addEventListener('touchend', handleEnd);
      dragBar.addEventListener('mousedown', handleStart);
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleEnd);
      
      // 点击遮罩层关闭
      modal.addEventListener('click', (e) => {
        if (e.target === modal && !isAnimating && isModalOpen) {
          isAnimating = true;
         // panel.style.transform = 'translateY(100%)';
          modal.classList.remove('show');
          isModalOpen = false;
          if(window.innerWidth <= 767){
              document.body.style.overflow = 'auto';
          }
          setTimeout(() => {
            resetModalStyle();
            unlockPage();
            isAnimating = false;
          }, 800);
        }
      });

      return {
        // 打开弹窗：完全不影响页面滚动位置
        open() {
          // if (isAnimating || isModalOpen) return;
          
          isAnimating = true;
          isModalOpen = true;
          lockPage(); // 仅阻止滚动事件，不修改页面样式
          
          // 重置弹窗样式
          resetModalStyle();
          
          // 显示遮罩层
          modal.classList.add('show');
          
          // 触发上滑入场动画
          requestAnimationFrame(() => {
            panel.classList.add('show');
            list.scrollLeft = 0;
            if(window.innerWidth <= 767){
              document.body.style.overflow = 'hidden'; // 移动端额外锁定滚动
          }
            // 动画结束后重置状态
            setTimeout(() => {
              isAnimating = false;
            }, 800);
          });
        },
        // 手动关闭弹窗
        close() {
          console.log('关闭对比弹窗2222');
          console.log(isAnimating)
          console.log(!isModalOpen);
          // if (isAnimating || !isModalOpen) return;
          if(window.innerWidth <= 767){
              document.body.style.overflow = 'auto';
          }

          isAnimating = true;
          //  panel.style.transform = 'translateY(100%)';
          // modal.classList.remove('show');
          // modal.style.transform = 'translateY(100%)';
          modal.classList.remove('show');
          isModalOpen = false;
          
          setTimeout(() => {
            resetModalStyle();
            unlockPage();
            isAnimating = false;
          }, 800);
        }
      };
    }